import { EmptyState } from '@vst/beam';
import { Alert } from '@vst/beam-icons/illustrative-icons';
import { useTranslation } from 'react-i18next';

import { NetworkLink } from '@app/router/constants';
import { useNavigate } from '@app/hooks';

import styles from './styles.module.scss';

export const RebootError = () => {
  const { replace } = useNavigate();

  const { t } = useTranslation('Network', { keyPrefix: 'rebootModem' });
  return (
    <div className={styles['pageContent']}>
      <EmptyState
        title={t('error.title')}
        icon={Alert}
        description={t('error.description')}
        actions={{
          primary: {
            label: t('error.button'),
            minWidth: '200px',
            onClick: () => replace(NetworkLink.Network),
          },
        }}
      />
    </div>
  );
};
